import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { GetExtensionDetail_extension_extensionFax } from '../../queries/generated/GetExtensionDetail';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-extension-fax-detail-left-column',
    styleUrls: ['./extension-fax-detail-left-column.component.scss', '../extension-detail-view.component.scss'],
    templateUrl: './extension-fax-detail-left-column.component.html',
    standalone: false
})
export class ExtensionFaxDetailLeftColumnComponent {
   @Input() extensionFax: GetExtensionDetail_extension_extensionFax | null;

   get formattedEmailAddress(): string[] {
      return this.extensionFax?.emailAddress?.split(',') || [];
   }
}
